/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：962
 */

var r = require(/* 257 */"../1754/257/index")
var o = require(/* 956 */"../1723/956")
var /* [auto-meaningful-name] */r$TYPED_ARRAY_CONSTRUCTOR = r.TYPED_ARRAY_CONSTRUCTOR
var /* [auto-meaningful-name] */r$aTypedArrayConstructor = r.aTypedArrayConstructor
module.exports = function (e) {
  return r$aTypedArrayConstructor(o(e, e[r$TYPED_ARRAY_CONSTRUCTOR]))
}
